<template>
    <div class="qksm">
        <p><b>（五）本部门重要的项目经费（一般项目）安排情况</b></p>
        <p>
            局本级：
        </p>
        <template v-for="(item, idx) in T7.本级">
            <p>
                {{idx+1}}.{{item.name}}{{isMoney(item.value)}}万元
            </p>
            <p class="indent">
                <div class="nogap">
                    <reason type="textarea" rows="3" classname="qksm widest" :name="'T7basis'+item.name" v-model:value="qksm['T7basis'+item.name]"></reason>
                    2022年预算安排情况为：
                    <reason type="textarea" rows="3" classname="qksm widest" :name="'T7content'+item.name" v-model:value="qksm['T7content' + item.name]"></reason>
                </div>
            </p>
        </template>
        <p>
            局属单位：
        </p>
        <template v-for="(item, idx) in T7.单位">
            <p>
                {{idx+1}}.{{item.name}}{{isMoney(item.value)}}万元
            </p>
            <p class="indent">
                <div class="nogap">
                    <reason type="textarea" rows="3" classname="qksm widest" :name="'T7basis'+item.name" v-model:value="qksm['T7basis'+item.name]"></reason>
                    2022年预算安排情况为：
                    <reason type="textarea" rows="3" classname="qksm widest" :name="'T7content'+item.name" v-model:value="qksm['T7content'+item.name]"></reason>
                </div>
            </p>
        </template>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm5",
        data() {
            var qksm = this.$store.state.divData.qksm;
            for (let item of this.T7.本级) {
                qksm['T7basis' + item.name] = this.pickOneOf(qksm['T7basis' + item.name], item.basis)
                qksm['T7content' + item.name] = this.pickOneOf(qksm['T7content' + item.name], item.content)
            }
            for (let item of this.T7.单位) {
                qksm['T7basis' + item.name] = this.pickOneOf(qksm['T7basis' + item.name], item.basis)
                qksm['T7content' + item.name] = this.pickOneOf(qksm['T7content' + item.name], item.content)
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },
        props: {
            T7: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
    };

</script>